import { APP_CONFIG } from '../config'
import { DOWNLOAD_IMAGE } from '../constants'

const download = async (fileId: string, signal: AbortSignal) => {
  const cache = await caches.open('my-cache')

  const url = `${APP_CONFIG.apiUrl}/${DOWNLOAD_IMAGE}?fileId=${fileId}`
  const request = new Request(url, {
    method: 'GET',
    signal,
  })

  const response = await cache.match(request)

  if (response) {
    const blob = await response.blob()

    const contentType = response.headers.get('content-type') ?? undefined
    const contentDisposition = response.headers.get('content-disposition')
    const fileName =
      contentDisposition?.split('filename=')[1].slice(1, -1) ?? 'fileName'

    const file = new File([blob], fileName, {
      type: contentType,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }) as any

    return file
  } else {
    cache.add(request)
    const fetchRequest = await fetch(request)

    const contentType = fetchRequest.headers.get('content-type')
    const contentDisposition = fetchRequest.headers.get('content-disposition')
    const fileName =
      contentDisposition?.split('filename=')[1].slice(1, -1) ?? 'fileName'

    const responseBlob = await fetchRequest.blob()
    if (contentType) {
      const blob = new Blob([responseBlob], { type: contentType })
      const file = new File([blob], fileName, {
        type: contentType,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }) as any

      return file
    }
  }
}

const fileApi = {
  download,
}

export default fileApi
